import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';
import { useDropdownPosition } from '../Custom_Hooks/useDropdownPosition';




// Utility function to separate compound units into simple units
const separateCompoundUnits = (mainUnitName, alternateUnitName) => {
    const units = [];

    // Function to extract simple units from compound unit string
    const extractUnitsFromString = (unitString) => {
        if (!unitString || unitString === 'Not Applicable' || unitString === '') {
            return [];
        }

        // Pattern to match compound units like "Box of 10 Nos", "Box of 1 kg", "Cont of 5 li"
        const compoundPattern = /(\w+)\s+of\s+(\d+)\s+(\w+)/i;
        const match = unitString.match(compoundPattern);

        if (match) {
            // Extract the units from compound unit
            const [, containerUnit, quantity, baseUnit] = match;
            return [
                { name: containerUnit, id: `${containerUnit}_container` },
                { name: baseUnit, id: `${baseUnit}_base` }
            ];
        } else {
            // If it's a simple unit, return as is
            return [{ name: unitString, id: `${unitString}_simple` }];
        }
    };

    // Extract units from main unit name
    const mainUnits = extractUnitsFromString(mainUnitName);
    units.push(...mainUnits);

    // Extract units from alternate unit name
    const alternateUnits = extractUnitsFromString(alternateUnitName);
    units.push(...alternateUnits);

    // Remove duplicates based on name
    const uniqueUnits = units.filter((unit, index, self) =>
        index === self.findIndex(u => u.name === unit.name)
    );

    return uniqueUnits;
};

const DropdownVoucherDynamicInput = forwardRef((
    {
        custom_class,
        title,
        state,
        input_value,
        input_key,
        input_id,
        input_blc,
        rawData,
        data,
        setData,
        setSubmitConfirm,
        inputRefs,
        index,
        modal_id,
        refs,
        narr_ref,
        isDynamic,
        handleDropdownClick,
        rowId,
        loading
    }, ref) => {


    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const coords = useDropdownPosition(state, ref);

    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
        isDynamic: isDynamic
    });
    let is_dropdown_clicked = false;

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        onItemSelect: (item) => {
            is_dropdown_clicked = true;
            selectedDataHandle(item);
        },
        onItemAltCSelect: () => {
            dispatch(closeModal(`${input_key}${modal_id || index}`));
            if (input_key === 'item_name') {
                dispatch(openModal("stockItemCreate"));
            } else if (input_key === 'godown_location') {
                dispatch(openModal("godownCreateVoucher"));
            } else {
                dispatch(openModal("ledgerCreate"));
            }
        },
        input_value,
    });

    const selectedDataHandle = (item) => {
        const new_data = data?.data?.filter((item1) => {
            const ledgerId = item1.particular_ledger_id;
            const targetId = item?.id || item?.ledger_id;
            return (ledgerId !== "" && ledgerId !== null && ledgerId !== undefined) && String(ledgerId) === String(targetId);
        });

        let get_amount;
        if (new_data.length > 0) {
            const lastEntry = new_data[new_data.length - 1];
            get_amount = lastEntry.particular_ledger_balance;
        } else {
            get_amount = item?.opening_balance;
        }

        setData((prevData) => {
            const updatedData = { ...prevData };
            if (typeof index !== "number") {
                updatedData[input_key] = item?.ledger_name || item?.name || item?.symbol;
            } else if (typeof index === "number") {
                if (input_key === 'payment_ledger_account') {
                    updatedData.payment_allocation = updatedData.payment_allocation.map((item_data, i) =>
                        i === index ? {
                            ...item_data,
                            ledger_name: item?.ledger_name,
                            [input_key]: item?.ledger_name,
                            [input_id]: item?.id || '',
                            [input_blc]: get_amount || ''
                        } : item_data
                    )
                } else if (updatedData.data_item) {
                    updatedData.data_item = updatedData.data_item.map((item_data, i) => {
                        const isMatch = rowId ? String(item_data.id) === String(rowId) : i === index;
                        if (isMatch) {
                            const displayName = item?.ledger_name || item?.name || item?.symbol;
                            if (input_key === 'item_name') {
                                if (displayName === 'End of List') {
                                    return { ...item_data, [input_key]: 'End of List', [input_id]: '', check_open: true };
                                }
                                return {
                                    ...item_data,
                                    [input_key]: displayName,
                                    [input_id]: item?.id || '',
                                    ['is_unit_available']: (item?.unit_name && item?.unit_name !== 'Not Applicable' && item?.unit_name !== '') ? true : false,
                                    ['item_units']: separateCompoundUnits(item?.unit_name, item?.alt_unit_name),
                                    ['per_unit']: item?.default_unit_rate,
                                    ['unit_name']: item?.unit_name,
                                    ['alt_unit_name']: item?.alt_unit_name,
                                    ['where_unit']: item?.where_unit,
                                    ['where_alternate_unit']: item?.where_alternate_unit,
                                    ['where_unit_name']: item?.where_unit_name,
                                    ['where_alternate_unit_name']: item?.where_alternate_unit_name,
                                };
                            } else {
                                if (displayName === 'End of List') {
                                    return { ...item_data, [input_key]: 'End of List', [input_id]: '' };
                                }
                                return { ...item_data, [input_key]: displayName, [input_id]: item?.id || '' };
                            }
                        }
                        return item_data;
                    });
                } else {
                    // Contra, Payment, Receipt, Journal
                    updatedData.data = updatedData.data.map((item_data, i) => {
                        const isMatch = rowId ? String(item_data.id) === String(rowId) : i === index;
                        if (isMatch) {
                            if (item?.ledger_name === 'End of List') {
                                return {
                                    id: item_data.id,
                                    first: 'End of List',
                                    particular_ledger_id: '',
                                    particular_ledger_balance: '',
                                    particular_ledger_pay_amount: '',
                                    prev_value: ''
                                };
                            }
                            return {
                                ...item_data,
                                [input_key]: item?.ledger_name,
                                [input_id]: item?.id || item?.ledger_id || '',
                                [input_blc]: get_amount || '',
                                // Explicit isolation for amount field
                                particular_ledger_pay_amount: item_data.particular_ledger_pay_amount || ''
                            };
                        }
                        return { ...item_data };
                    });
                }
            }
            return updatedData;
        });

        dispatch(closeModal(`${input_key}${modal_id || index}`));

        if (handleDropdownClick) {
            setTimeout(() => {
                handleDropdownClick(input_key, item?.ledger_name || item?.name || item?.symbol, rowId || index);
            }, 50);
        }

    }

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div 
            className={`${custom_class ? custom_class : 'dropdown-content-list'} ${state ? 'show-list' : ''}`}
            style={{
                ...coords,
                display: state ? 'flex' : 'none',
                flexDirection: 'column',
                overflow: 'hidden',
                padding: 0
            }}
        >
            <div className='col' style={{ background: 'skyblue', position: 'sticky', top: 0, flexShrink: 0 }}>
                {title}
            </div>

            <div id='data' ref={dropdownRef} style={{ overflowY: 'auto', flex: 1 }}>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <i className="fas fa-spinner fa-spin me-2"></i>
                        <span>Loading...</span>
                    </div>
                ) : Array.isArray(filteredData) && filteredData?.map((key, number) => {
                    const name = key?.ledger_name || key?.name || key?.symbol;
                    const formal_name = key?.formal_name
                    const type = key?.type
                    const balance = key?.opening_balance;
                    const id = key?.id;
                    const index_1 = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                    return (
                        <Link
                            className={`list  ${number === selectedItemIndex ? 'selected' : ''}`}
                            id='list'
                            key={number}
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedItemIndex(number);
                                is_dropdown_clicked = true;
                                selectedDataHandle(key);
                            }}
                        >
                            <div className='row m-0'>
                                <div className={formal_name ? 'col-6 p-0' : 'col-12 p-0'}>
                                    {name === 'End of List' ? (
                                        <>
                                            <i className="fas fa-diamond me-2" style={{ fontSize: '7px', verticalAlign: 'middle', height: '12px' }}></i>
                                            {index_1 !== -1 ? (
                                                <>
                                                    {name?.substring(0, index_1)}
                                                    <span style={{ color: 'red' }}>{name?.substring(index_1, index_1 + input_value?.length)}</span>
                                                    {name?.substring(index_1 + input_value?.length)}
                                                </>
                                            ) : (
                                                name
                                            )}
                                        </>
                                    ) : index_1 !== -1 ? (
                                        <>
                                            {name?.substring(0, index_1)}
                                            <span style={{ color: 'red' }}>{name?.substring(index_1, index_1 + input_value?.length)}</span>
                                            {name?.substring(index_1 + input_value?.length)}
                                        </>
                                    ) : (
                                        name
                                    )}

                                </div>
                                {
                                    formal_name ?
                                        <div className='col-6'>
                                            {formal_name && type === 'Simple' ? `(${formal_name})` : null}
                                        </div> : null
                                }
                            </div>
                        </Link>
                    );
                })
                }

            </div>
        </div>
    )
})

export default React.memo(DropdownVoucherDynamicInput)
